if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // 过滤未填写的定制属性，避免无意义空值提交
        [
          "properties[_ci_slug]",
          "properties[_ci_text]",
          "properties[_ci_image]",
          "properties[_ci_align]",
        ].forEach((key) => {
          if (formData.get(key) === "") {
            formData.delete(key);
          }
        });

        config.body = formData;

        function quick_add_appendChild() {
          let quick_add = document.querySelectorAll(
            ".drawer .cart-drawer .gradient .centent .left .card-wrapper .card .card__content .card__information .add_btn .quick-add quick-add-modal ",
          );
          const body = document.body;

          quick_add.forEach((element) => {
            body.appendChild(element);
          });

          let quick_addsss = document.querySelectorAll(
            ".drawer .cart-drawer .gradient .centent .left .card-wrapper .card .card__content .card__information .add_btn .quick-add.no-js-hidden modal-opener",
          );

          quick_addsss.forEach((item) => {
            item.onclick = function () {
              const cart_drawer = document.querySelector("cart-drawer.drawer");

              if (cart_drawer.classList.contains("active")) {
                cart_drawer.classList.remove("active");
              }
            };
          });
        }
        function recommendations() {
          console.log(123);
          let cartItems = document.querySelectorAll(
            ".drawer .cart-drawer .gradient .centent .right cart-drawer-items table tbody tr",
          );
          let recommendationsSection = document.querySelector(
            ".drawer .cart-drawer .gradient .centent .left",
          );
          let recommendationsSectionser = document.querySelector(
            ".drawer .cart-drawer .gradient .centent .right cart-drawer-items .left",
          );

          let hasRecommendations = false;
          let hasNoRecommendations = false;
          if (cartItems) {
            cartItems.forEach((item) => {
              if (item.hasAttribute("no-recommendations")) {
                hasNoRecommendations = true;
              }
              if (item.hasAttribute("recommendations")) {
                hasRecommendations = true;
              }
            });
          }

          // Apply display logic
          if (recommendationsSection) {
            if (hasNoRecommendations) {
              recommendationsSection.style.display = "none";
            } else if (hasRecommendations) {
              recommendationsSection.style.display = "flex";
            } else {
              // Default case if neither attribute exists
              recommendationsSection.style.display = "none";
            }
          }
        }

        setTimeout(function () {
          quick_add_appendChild();
          recommendations();
        }, 2000);

        let product_list = [];

        const product_form_dom = document.querySelector(
          ".product__info-container .sales-activities",
        );
        const Bundle_product = document.querySelector(
          '.Bundle .list .item:nth-child(1)[data-cart_open="false"]',
        );
        const isBundleAddonForm = Boolean(this.closest(".Bundle"));

        if (product_form_dom) {
          const product_items =
            product_form_dom.querySelectorAll(".product-item");
          product_items?.forEach((item) => {
            if (item.getAttribute("data-choose") == "true") {
              product_list.push(item.getAttribute("data-product-id"));
            }
          });
        }
        if (Bundle_product && isBundleAddonForm) {
          const bundleQuantity = Bundle_product.querySelector(
            ".cart_qty .quantity-cart",
          );
          const quantity = bundleQuantity
            ? parseFloat(bundleQuantity.textContent)
            : 0;

          if (quantity < 1) {
            // 你的操作

            if (Bundle_product.getAttribute("product-id") != "") {
              product_list.push(Bundle_product.getAttribute("product-id"));
            }
          }
        }
        const data = {
          items: [],
          sections: "cart-drawer,cart-icon-bubble",
        };
        if (product_list.length > 0) {
          product_list.forEach((item) => {
            data.items.push({
              id: item,
              quantity: 1,
            });
          });

          await fetch(`${routes.cart_add_url}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
        }
        setTimeout(() => {
          const productScope =
            this.closest("quick-add-modal") ||
            this.closest("product-info") ||
            this.closest(".shopify-section") ||
            document;
          const bottomQuantityInput = productScope.querySelector(".hw-bottom-quantity-input");

          if (bottomQuantityInput) bottomQuantityInput.value = 1;
          console.log(123898989898989);
        }, 1000);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");

            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}
